/**
 * Reject any redirect target that isn't a same-origin relative path.
 *
 * Accepts: `/foo`, `/foo/bar?x=1`
 * Rejects: `//evil.com/...` (protocol-relative), `https://evil.com/...`,
 * `/\evil.com` (backslash trick), empty / null / undefined.
 *
 * Used by every place we forward the user after sign-in (login page,
 * /auth/callback, middleware-set `redirect` param) so a crafted link
 * `?callbackUrl=//evil.com` can't bounce the user off-site after auth.
 */
export function isSafeRedirect(value: string | null | undefined): value is string {
  if (!value) return false
  if (!value.startsWith('/')) return false
  // Block protocol-relative (`//host`) and backslash variants browsers normalize.
  if (value.length > 1 && (value[1] === '/' || value[1] === '\\')) return false
  return true
}

export function safeRedirectOr(value: string | null | undefined, fallback = '/'): string {
  return isSafeRedirect(value) ? value : fallback
}
